import axios from "~/plugins/axios";

export default {
  interstRates(object) {
    const url = "/web_api/v1/mint/interest_rates";

    return axios.post(url, object).then((response) => response.data);
  },
};
